export default function getWorkerOperationalState(profile = {}) {
  const status = String(profile?.status || "").trim().toLowerCase();

  const onboardingStatus = String(
    profile?.onboardingStatus || ""
  )
    .trim()
    .toLowerCase();

  const workerStatus = String(
    profile?.workerStatus || ""
  )
    .trim()
    .toLowerCase();

  const complianceStatus = String(
    profile?.complianceStatus || ""
  )
    .trim()
    .toLowerCase();

  const operationalState = String(
    profile?.workerOperationalState || ""
  )
    .trim()
    .toUpperCase();

  const registrationStatus = String(
    profile?.registrationStatus || ""
  )
    .trim()
    .toLowerCase();

  const archived =
    profile?.archived === true ||
    status === "archived";

  const disabled =
    profile?.disabled === true;

  if (archived) {
    return {
      key: "archived",
      label: "ARCHIVED",
      description: "Worker record is archived",
      tone: "slate",
      ready: false,
      available: false,
    };
  }

  if (
    disabled ||
    status === "inactive" ||
    workerStatus === "inactive" ||
    operationalState === "INACTIVE"
  ) {
    return {
      key: "inactive",
      label: "INACTIVE",
      description: "Worker is currently inactive",
      tone: "slate",
      ready: false,
      available: false,
    };
  }

  if (
    registrationStatus === "pending" ||
    registrationStatus === "invited" ||
    workerStatus === "registration_pending" ||
    operationalState === "REGISTRATION_PENDING"
  ) {
    return {
      key: "registration_pending",
      label: "REGISTRATION PENDING",
      description: "Registration approval is required",
      tone: "amber",
      ready: false,
      available: false,
    };
  }

  if (
    onboardingStatus === "reupload_required" ||
    onboardingStatus === "rejected" ||
    complianceStatus === "reupload_required" ||
    complianceStatus === "rejected" ||
    operationalState === "ACTION_REQUIRED"
  ) {
    return {
      key: "action_required",
      label: "ACTION REQUIRED",
      description: "Worker must correct onboarding or compliance items",
      tone: "danger",
      ready: false,
      available: false,
    };
  }

  if (
    onboardingStatus === "submitted" ||
    onboardingStatus === "pending_review" ||
    onboardingStatus === "under_review" ||
    workerStatus === "under_review" ||
    complianceStatus === "pending_review" ||
    complianceStatus === "under_review" ||
    operationalState === "UNDER_REVIEW"
  ) {
    return {
      key: "under_review",
      label: "UNDER REVIEW",
      description: "Documents are awaiting admin review",
      tone: "amber",
      ready: false,
      available: false,
    };
  }

  if (
    onboardingStatus === "registered" ||
    onboardingStatus === "onboarding" ||
    onboardingStatus === "missing_docs" ||
    onboardingStatus === "in_progress" ||
    workerStatus === "onboarding" ||
    operationalState === "ONBOARDING"
  ) {
    return {
      key: "onboarding",
      label: "ONBOARDING",
      description: "Worker onboarding is incomplete",
      tone: "amber",
      ready: false,
      available: false,
    };
  }

  const approvedOnboarding =
    onboardingStatus === "approved" ||
    profile?.onboardingCompleted === true;

  const approvedCompliance =
    complianceStatus === "approved" ||
    complianceStatus === "ready";

  const readyWorkerStatus =
    workerStatus === "ready";

  const readyOperationalState =
    operationalState === "READY";

  const activeStatus =
    status === "active";

  const isReady =
    readyOperationalState ||
    (
      activeStatus &&
      approvedOnboarding &&
      approvedCompliance &&
      readyWorkerStatus
    );

  if (isReady) {
    const availabilityStatus = String(
      profile?.availabilityStatus || "available"
    )
      .trim()
      .toLowerCase();

    const isAvailable =
      availabilityStatus === "available" &&
      profile?.disabled !== true;

    return {
      key: "ready",
      label: "READY",
      description: isAvailable
        ? "Approved and available for scheduling"
        : "Approved but currently unavailable",
      tone: "green",
      ready: true,
      available: isAvailable,
    };
  }

  return {
    key: "not_ready",
    label: "NOT READY",
    description: "Worker has not completed all readiness requirements",
    tone: "slate",
    ready: false,
    available: false,
  };
}